import { action, makeObservable, observable } from 'mobx';
import { InputVM } from './InputVM';
import { makeMetadata, property } from '../helpers/decorators';

export class PrimitiveVM extends InputVM {
  constructor(...args: any[]) {
    super(...args);
    makeObservable(this);
    makeMetadata(this);
  }

  /**
   * 当前VM的data信息
   * @example
   *
   */
  @property
  @observable
  data: any = undefined;

  /**
   * 更新当前VM的data信息
   * @param data
   */
  @action
  setData(data: any): this {
    this.data = data;
    return this;
  }
}
